export default "__VITE_ASSET__CjIo2Xt7__"